import { Box, Chip, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableFooter } from '@mui/material';

// Components
import { HeaderTableCell } from 'components/TransactionsSection/table/HeaderTableCell';
// Utils and Helpers
import { CARD_TRANSACTION_TYPE } from 'helpers/constants';
import { formatDate } from 'helpers/formatDate';
import { numberFormat } from 'helpers/i18n';

const TableColumns = [
    {
        id: 'dateAdded',
        label: 'DATE',
        minWidth: 200,
        align: 'center',
        format: value => value.toLocaleString('en-US')
    },
    { id: 'paymentId', label: 'TRANSACTION ID', minWidth: 80, align: 'center' },
    {
        id: 'status',
        label: 'STATUS',
        minWidth: 200,
        align: 'right'
    },
    {
        id: 'amount',
        label: 'AMOUNT',
        minWidth: 200,
        align: 'center'
    }
];

const statusFormat = cardTransaction => {
    let transactionTypeName;
    if (cardTransaction?.type === CARD_TRANSACTION_TYPE.SPEND_UPDATE) {
        transactionTypeName = cardTransaction?.type?.split('.')[2];
    } else {
        transactionTypeName = cardTransaction?.type?.split('.')[1];
    }
    const parentTransaction = cardTransaction?.id_parent_card_transaction;

    let label = transactionTypeName;
    if (parentTransaction) {
        label += ` (${'...' + parentTransaction.substring(parentTransaction.length - 6)})`;
    }
    if (cardTransaction?.type === CARD_TRANSACTION_TYPE.DECLINED) {
        return <Chip label={label} className="chip chip-danger fw-bold" />;
    }
    if (cardTransaction?.type === CARD_TRANSACTION_TYPE.REFUND) {
        return <Chip label={label} className="chip chip-warning fw-bold" />;
    }
    if (cardTransaction?.type === CARD_TRANSACTION_TYPE.SPEND_UPDATE) {
        return <Chip label={label} className="chip chip-success fw-bold" />;
    }
    if (cardTransaction?.type === CARD_TRANSACTION_TYPE.REVERSAL) {
        return <Chip label={label} className="chip chip-danger fw-bold" />;
    }
    if (cardTransaction?.type === CARD_TRANSACTION_TYPE.REPLENISH) {
        return <Chip label={label} className="chip chip-pending fw-bold" />;
    }
};

function ChildTransactionsTable({ childrenTransactions, setTransactionId }) {
    const handleRedirect = targetTransactionID => {
        setTransactionId(targetTransactionID);
    };

    return (
        <Paper
            sx={{
                width: '100%',
                overflow: 'hidden',
                marginBottom: '3em'
            }}>
            <TableContainer sx={{ maxHeight: 1440 }}>
                <Table stickyHeader aria-label="sticky table" sx={{ border: 'none' }}>
                    <TableHead>
                        <TableRow>
                            {TableColumns.map((column, index) => (
                                <HeaderTableCell value={column.label} key={column.label} index={index} />
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody sx={{ height: childrenTransactions.results.length === 0 && '600px' }}>
                        {!!childrenTransactions.results.length &&
                            childrenTransactions.results.map(row => (
                                <TableRow key={row.id} hover role="checkbox">
                                    <TableCell className="card-table-row-cell" align="left">
                                        {formatDate(row.created_at)}
                                    </TableCell>
                                    <TableCell className="card-table-row-cell" align="left">
                                        <Box sx={{ color: '#4ABDE9', cursor: 'pointer' }} onClick={() => handleRedirect(row?.id)}>
                                            {row.id}
                                        </Box>
                                    </TableCell>
                                    <TableCell sx={{ justifyContent: 'center' }}>{statusFormat(row)}</TableCell>
                                    <TableCell className="card-table-row-cell">
                                        <Box className="fw-bold">{numberFormat(row.amount, 2, 2)}</Box>
                                    </TableCell>
                                </TableRow>
                            ))}
                    </TableBody>
                    <TableFooter sx={{ backgroundColor: '#f5f5f5' }}>
                        <TableRow>
                            <TableCell className="card-table-row-cell" align="left" colSpan={TableColumns.length - 1}>
                                <Box sx={{ fontWeight: 'bold' }}>Net Transaction Amount</Box>
                            </TableCell>
                            <TableCell className="card-table-row-cell" align="right">
                                <Box sx={{ fontWeight: 'bold' }}>{numberFormat(childrenTransactions.totalAmount, 2, 2)}</Box>
                            </TableCell>
                        </TableRow>
                    </TableFooter>
                </Table>
            </TableContainer>
        </Paper>
    );
}

export default ChildTransactionsTable;
